module.exports = __webpack_public_path__ + "static/13-Conference-Room-a47a2e165b12a0e9f7c3ae21eea62a90.jpg";